import { ETAB_ROUTES, META_DASHBOARD_SIDEMENU, META_DASHBOARD_TABS, META_MOBILE_NAVIGATION_TABS } from "@etab/config";

import RecruitmentsPage from "./Recruitments.page.vue";
import UpcomingTab from "./Upcoming.tab.vue";
import InProgressTab from "./InProgress.tab.vue";

export default function () {
  return [
    {
      path: ETAB_ROUTES.dashboard.tabs.root.path,
      name: ETAB_ROUTES.dashboard.tabs.root.name,
      component: RecruitmentsPage,
      meta: {
        [META_MOBILE_NAVIGATION_TABS]: true,
        [META_DASHBOARD_TABS]: true,
        [META_DASHBOARD_SIDEMENU]: true,
      },
      redirect: { name: ETAB_ROUTES.dashboard.tabs.upcoming.name },
      children: [
        {
          path: ETAB_ROUTES.dashboard.tabs.upcoming.path,
          name: ETAB_ROUTES.dashboard.tabs.upcoming.name,
          component: UpcomingTab,
        },
        {
          path: ETAB_ROUTES.dashboard.tabs.inProgress.path,
          name: ETAB_ROUTES.dashboard.tabs.inProgress.name,
          component: InProgressTab,
        },
      ],
    },
  ];
}
